/** Web: доступ к камере спрашивает сам браузер при `<input capture>`. */
export async function requestAndroidCameraPermission(): Promise<boolean> {
  return true;
}
